import type { CSSProperties } from 'react'

/** Shared inline styles for Base UI popups/menus and topbar icon buttons. */

export const POPUP_STYLE: CSSProperties = {
  background: 'var(--bg-elev)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--r-md)',
  boxShadow: 'var(--sh-4)',
  padding: 4,
  minWidth: 220,
  fontFamily: 'var(--ff-ui)',
  color: 'var(--text)',
  outline: 'none',
}

export const MENU_ITEM_STYLE: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  padding: '8px 10px',
  borderRadius: 'var(--r-sm)',
  fontSize: 13,
  color: 'var(--text-soft)',
  cursor: 'pointer',
  userSelect: 'none',
  outline: 'none',
  border: 0,
  background: 'transparent',
  textAlign: 'left',
}

export const GROUP_LABEL_STYLE: CSSProperties = {
  padding: '8px 10px 4px',
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--text-faint)',
}

export const ICON_BTN_STYLE: CSSProperties = {
  width: 32,
  height: 32,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'var(--r-sm)',
  border: 0,
  background: 'transparent',
  color: 'var(--text-mute)',
  cursor: 'pointer',
  position: 'relative',
  font: 'inherit',
}

export const TOOLTIP_STYLE: CSSProperties = {
  background: 'var(--bg-elev)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--r-sm)',
  boxShadow: 'var(--sh-3)',
  padding: '5px 9px',
  fontSize: 12,
  color: 'var(--text)',
  fontFamily: 'var(--ff-ui)',
}
